module.exports = __webpack_public_path__ + "static/img/PRCbayinhan.e4bc490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/PRCbayinhan.jpg
// module id = 35uP
// module chunks = 1